import React from 'react';
import Box from '@mui/material/Box';
import { useSelectByTheme } from '@/lib/themeAssets';

export default function NeutralOrDarkProfileSVG({ size = 40 }: { size?: number }) {
  const src = useSelectByTheme(
    "/signin-assets/dark/web_dark_rd_na.svg",
    "/signin-assets/light/web_light_rd_na.svg",
    "/signin-assets/neutral/web_neutral_sq_ctn.svg"
  );
  return (
    <Box
      component="img"
      src={src}
      alt="Sign in or profile placeholder"
      sx={{ width: size, height: size, display: 'block' }}
    />
  );
}
